<template>
  <div v-if="body_show">
    <!--  -->
    <div class="task-box task2" v-if="show_new_task">
      <div class="task-title">
        {{ title }}
      </div>
      <div v-for="(item, index) in dynamicData" :class="[item.type === 'select2' ? 'in-block' : '', 'task-box task2 task-plr-reset']">
        <!-- fill -->
        <div v-if="item.type === 'fill'" class="task_f">
          <h3 class="label">{{ item.label }}</h3>
          <div class="clearfix">
            <div v-if="item.yield" v-for="item2 in item.list" class="task_ninput pull-left">
              <span v-if="!item2.attr">{{item2.label}}</span>
              <input v-if="item2.attr" v-model="item2.value" type="text" class="task_n" />
              <span v-if="item2.attr">{{item2.label}}</span>
            </div>
          </div>
        </div>
        <!-- title -->
        <div v-if="item.type === 'title'" class="task_f">
            <h3 class="label">{{ item.label }}<span v-if="item.config">{{item.config.subtitle.text}}</span></h3>
        </div>
        <!-- tip -->
        <div v-if="item.type === 'tips'" class="task_f">
          <h3 class="label">{{item.label}}
            <span v-for="item2 in item.list" @click="showTagModul(item2.tip, item2.lab, item2.val)" :class="item2.tip ? 'noun' : ''">{{item2.tip ? item2.lab : item2}}</span>
          </h3>
        </div>
        <!-- select1 -->
        <div v-if="item.type === 'select1'" class="cell project4-task-row clearfix">
          <div v-for="item2 in item.list" class="pull-left">
            <van-cell-group v-if="item2.attr" class="grouping project3-task1 pull-left clearfix">
              <van-field v-model="item2.value" @click="showPicker(item2.select, item2)" readonly />
              <label class="choose_lable"></label>
            </van-cell-group>
            <span v-if="item2.attr" class="pull-left">{{item2.label}}</span>
            <span v-else class="pull-left">{{item2.label}}</span>
          </div>
        </div>
        <!-- select2 -->
        <div v-if="item.type === 'select2'" class="cell project4-task-row clearfix">
          <span class="pull-left">{{item.label}}</span>
          <van-cell-group class="grouping project3-task1 mt-reset pull-left clearfix">
            <van-field v-model="item.value" @click="showPicker(item.select, item)" readonly />
            <label class="choose_lable"></label>
          </van-cell-group>
        </div>
        <!-- textarea -->
        <div v-if="item.type === 'textarea'" class="cell clearfix">
          <div class="task_f mt-reset clearfix">
            <h3 class="label task_pb10">{{item.label}}<span v-if="item.tips">{{item.tips}}</span></h3>
            <div class="input-mt mt-reset">
              <textarea v-model="item.value" @input="changeVal($event, item, item.config.length)" :placeholder="item.config.tips"></textarea>
            </div>
            <span class="float">{{item.value.length}}/{{item.config.length}}</span>
          </div>
        </div>
      </div>
      <div class="submitBtn">
        <van-button @click="dynDataSub"  :class="verification() ? 'actice' : ''">提交</van-button>
      </div>
      <!-- 选择 -->
      <van-popup v-model="picker_show" position="bottom">
          <van-picker show-toolbar :columns="selectList" @cancel="picker_show = false" @confirm="confirmVal" />
      </van-popup>
      <!-- 弹出标签 -->
      <van-popup class="explain" v-model="tagModul">
        <div>
          <h2>{{ tagModulData.title }}</h2>
          <div class="pps" v-html="tagModulData.content"></div>
        </div>
      </van-popup>
    </div>
    <!--  -->
    <div v-else class="task-box task2">
      <div class="task-title">
        {{ title }}
      </div>
      <h3 class="pj-task-h3">1.请确认你的&nbsp;<span class="bt" @click="alertModule1=true">简历2.0</span>&nbsp;是通过“简历5步法”修改与打磨简历。</h3>
      <h3 class="task-small-h3">2.把简历转成图⽚格式，并在下⾯上传。</h3>
      <h3 class="task-small-h3">3. 请再次确认你的下列资料，我们会把你的信息录⼊⼈才库，有机会为你提供更个性化的职业发展服务。</h3>

      <div class="task_f">
        <h3 class="label">真实姓名</h3>
        <div class="input-box input-mt">
          <div>
            <input v-model="fullname" type="text" placeholder="请填写自己的真实姓名" />
          </div>
        </div>
      </div>

      <div class="task_f">
        <h3 class="label">意向行业</h3>
        <div class="input-box input-mt on">
          <van-cell-group class="grouping on">
            <van-field placeholder="请填写自己的意向行业" v-model="intention_career_name" @click="pickerType(1)" readonly />
            <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
          </van-cell-group>
        </div>
        <input v-if="intention_career_name =='其它行业'" class="is-show" v-model="intention_career_name_two" type="text" placeholder="请填写自己的意向行业" />
      </div>

      <div class="task_f">
        <h3 class="label">求职岗位</h3>

        <div v-if="intention_career_name !='其它行业'" class="input-box input-mt on">
          <van-cell-group class="grouping on">
            <van-field placeholder="请填写自己的求职岗位" v-model="intention_job_name" @click="intentionJob" readonly />
            <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
          </van-cell-group>
        </div>
        <div v-else-if="intention_job_name != '其它岗位'" :class="['input-box',intention_career == '0'?'input-mt on':'']">
          <div class="son">
            <input v-model="intention_job_name" type="text" placeholder="请填写自己的求职岗位" />
          </div>
        </div>
        <input v-if="intention_job=='0' && intention_job_name=='其它岗位'" class="is-show" v-model="intention_job_name_two" type="text" placeholder="请填写自己的求职岗位" />
      </div>

      <div class="task_f">
        <h3 class="label">求职地区</h3>
        <div class="input-box input-mt on">
          <van-cell-group class="grouping on">
            <van-field placeholder="请选择自己的求职地区" v-model="intention_area" @click="citys_show=true" readonly />
            <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
          </van-cell-group>
        </div>
        <van-popup v-model="citys_show" position="bottom">
          <van-area ref="areas" :area-list="areaList" :columns-num="2" @cancel="cityCancel" @confirm="cityConfirm" />
        </van-popup>
      </div>

      <div class="task_f">
        <h3 class="label">简历</h3>
        <div class="input-box upload-on on">
          <a v-if="uploadImgBool" href="javascript:;" @click="uploadImgHandle">
            <img :src="targetheadimg" />
          </a>
          <a href="javascript:;" v-else >
            <van-uploader  name="uploader" :after-read="onRead">
              <img :src="targetheadimg" />
            </van-uploader>
          </a>
          <p>（请上传自己的简历，图片格式）</p>
        </div>
      </div>

      <div class="submitBtn">
        <van-button v-if="validationHandle()" @click="submitHandle" class="actice">提交</van-button>
        <van-button v-else>提交</van-button>
      </div>
    </div>


    <!-- 弹出内容2 -->
    <van-popup class="explain" v-model="alertModule1">
      <div>
        <h2>简历2.0</h2>
        <div class="pps">
          简历2.0不仅用于求职，更加用于整理自己职业档案，吸引潜在关注者，建立个人品牌。2.0的意思是，这不仅仅是一个呈现信息的简历。而是能够针对职业目标，展示个人能力、资源、态度和独特性。
        </div>
      </div>
    </van-popup>
    <van-popup v-model="picker_show" position="bottom">
      <!-- 意向行业 -->
      <van-picker v-if="picker_type==1" show-toolbar :columns="intention_career_group" @cancel="cancel" @confirm="confirm" />
      <!-- 求职岗位 -->
      <van-picker v-if="picker_type==2" show-toolbar :columns="intention_job_group" @cancel="cancel" @confirm="confirm" />
    </van-popup>
    <!-- 弹出层 -->
    <van-popup :close-on-click-overlay="false" v-model="nextModule">
      <div class="modules">
        <div class="head clearfix">
          <img @click="nextModule = false" class="close" src="@a/close.png" alt="" />
        </div>
        <div class="con-img">
          <img src="@a/pr1.png" alt="图片正在加载中..." />
        </div>
        <div class="con-text">
          任务就像消消乐，完成就好，继续加油！
        </div>
        <router-link class="next-btn" :to="{path: 'project4_task3_new', query: objArg}">去开启下一任务</router-link>
      </div>
    </van-popup>
  </div>
</template>
<script>
import areaList from '@/utils/area'
import { getStorage, setStorage, isMain,mobileOrWin } from "@/utils/tools"
import { get_selfstock_data, update_selfstock_data, upload_image, index, subtable,upload_image_file,save_image } from "@/api/course"
import { shareCon } from "@/utils/wxconfig"
import wx from "weixin-js-sdk"
let imgSrc = require('../../../assets/upload_img.png');
export default {
  data() {
      return {
        body_show: false,
        arrow: false,
        title: 'T2：提交打磨过的简历',
        areaList,
        alertModule1: false,
        citys_show: false,
        picker_show: false,
        serverId: '',
        fullname: '',
        targetheadimg: '',
        intention_area: '',
        intention_career: '',
        intention_job: '',
        intention_career_name: '',
        intention_career_name_two: '',
        intention_job_name: '',
        intention_job_name_two: '',
        intention_career_group: [],
        intention_job_group: [],
        picker_type: 0,
        intention_work: [],
        headImg: false,
        nextModule: false,
        objArg: {
          cid: "",
          pid: "",
          id: "",
          name: ""
        },
        //
        dynamicData: [],
        form_id: '',
        tagModul: false,
        picker_show: false,
        tagModulData: {
            title: "默认标题",
            content: "默认标签提示内容"
        },
        selectItem: null,
        backupList: {},
        selectList: [],
        // 上传图片类型
        uploadImgBool:true,
        image_url:''
      }
    },
    computed: {
      show_new_task(){
        let q = this.$route.query;
        if(!isMain()){
          return true
        }
        if(isMain() && (q.cid == 5 || q.cid >= 7)){
          return true
        }
        return false
      }
    },
    methods: {
      // 上传图片判断
      onRead(files,detail){
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("image", files.file);
  
        // 上传图片接口
        upload_image_file(form).then((res) => {
          if (res.code ==10002) {
            this.$toast(res.msg);
            return
          }
          save_image({
            cid: this.$route.query.cid,
            head:res.image_url
          }).then(data => {
              this.targetheadimg = res.image_url;
            });
        });
      },
      changeVal(ev, item, maxLen){
        let tarLen = ev.target.value.length;
        if(tarLen > maxLen){
          item.value = item.value.substring(0, maxLen);
        }
      },
      verification(){
        for(let arg of this.dynamicData){
          if(arg.type === 'fill' || arg.type === 'select1'){
            for(let arg2 of arg.list){
              if(arg2.attr && !arg2.value){
                return
              }
            }
          }else if(arg.type === 'select2' || arg.type === 'textarea'){
            if(!arg.value){
              return
            }
          }
        }
        return true
      },
      getDynData(){
        let newData = []
        for(let arg of this.dynamicData){
          if(arg.type === 'fill' || arg.type === 'select1'){
            let conJson = {};
            for(let item of arg.list){
              if(item.attr){
                conJson[item.attr] = item.value
              }
            }
            newData.push({
              'field_id': arg.id,
              'content': JSON.stringify(conJson)
            })
          }else if(arg.type === 'select2' || arg.type === 'textarea'){
            newData.push({
              'field_id': arg.id,
              'content': arg.value
            })
          }
        }
        return newData
      },
      dynDataSub(){
        let testResult = this.verification();
        if(!testResult){
          return
        }
        // loading
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        // 成立
        let getData = this.getDynData();
        // console.log(JSON.stringify(getData));
        let q = this.$route.query;
        subtable({
          cid: q.cid,
          type: "taskone",
          cpid: q.pid,
          cptid: q.id,
          form_id: this.form_id,
          field: JSON.stringify(getData)
        })
        .then((data) => {
          let q = this.$route.query;
          this.$toast.clear();
          this.nextModule = true;
          this.objArg.cid = q.cid;
          this.objArg.id = Number(q.id) + 1;
          this.objArg.pid = q.pid;
          this.objArg.name = encodeURIComponent(data.name);
        })
      },
      confirmVal(val){
        this.selectItem.value = val;
        this.picker_show = false;
      },
      showPicker(select, item){
        this.picker_show = true;
        this.selectItem = item;
        this.selectList = select;
      },
      showTagModul(bool, title, content){
        if(!bool){
          return
        }
        this.tagModul = true;
        this.tagModulData['title'] = title;
        this.tagModulData['content'] = content;
      },
      intentionJob() {
        if (!this.$Validator.isEmpty(this.intention_career_name)) {
          this.pickerType(2);
        } else {
          this.$toast('请先选择行业！');
        }
      },
      pullData() {
        let q = this.$route.query;
        if(this.show_new_task){
          // 新版本
          this.dynamicData = [];
          index({
            cid: q.cid,
            cpid: q.pid,
            cptid: q.id
          })
          .then(data => {

            this.title = data.title;
            let isReset = !!data.userfield.length;

            let userData = data.userfield;
            let newJSON = {};
            for(let arg of userData){
              newJSON[arg.field_id] = arg.content;
            }

            // 没有编辑过
            let list = data.field;
            this.form_id = list[0].form_id;
            // 取默认数据
            for(let arg of list){
              if(arg.type === 'fill'){
                // 存key
                let nk = {};
                for(let [index, arg2] of arg.config.text.entries()){
                  if(arg2.attr){
                    arg2.value = '';
                    nk[arg2.attr] = index;
                  }
                  if(!isReset && arg2.attr){
                    arg2.value = arg.config.variable[arg2.attr].content;
                  }
                }
                let nd = {
                  id: arg.id,
                  type: 'fill',
                  yield: true,
                  label: arg.label,
                  back: nk,
                  list: arg.config.text
                };
                if(isReset){
                  let sc = JSON.parse(newJSON[nd.id]);
                  for(let attr in nk){
                    let index = nk[attr];
                    let value = sc[attr];
                    nd.list[index].value = value;
                  }
                }
                this.dynamicData.push(nd)
              }else if(arg.type === 'title'){
                this.dynamicData.push({
                  id: arg.id,
                  type: 'title',
                  yield: false,
                  config: arg.config,
                  label: arg.label
                })
              }else if(arg.type === 'tips'){
                let j = arg.config.subtitle.difficult;
                let t = arg.config.subtitle.text;
                let key;
                for(let attr in j){
                  key = attr;
                }
                let arr = t.split(key);
                arr[2] = arr[1];
                arr[1] = {
                  tip: true,
                  lab: key,
                  val: j[key].content.replace(/\n/ig, '<br/>')
                }
                this.dynamicData.push({
                  id: arg.id,
                  type: 'tips',
                  yield: true,
                  label: arg.label,
                  list: arr
                })
              }else if(arg.type === 'select'){
                let text = arg.config.text;
                let json = arg.config.variable;
                // 多项
                if(text){
                  let nk = {}
                  for(let [index, arg2] of text.entries()){
                    if(arg2.attr){
                      arg2.value = '';
                      arg2.select = json[arg2.attr].content;
                      nk[arg2.attr] = index;
                    }
                  }
                  let nd = {
                    id: arg.id,
                    type: 'select1',
                    yield: true,
                    back: nk,
                    list: text
                  }
                  if(isReset){
                    let sc = JSON.parse(newJSON[nd.id]);
                    for(let attr in nk){
                      let index = nk[attr];
                      let value = sc[attr];
                      nd.list[index].value = value;
                    }
                  }
                  this.dynamicData.push(nd)
                }else{
                  let nd = {
                    id: arg.id,
                    type: 'select2',
                    yield: false,
                    value: '',
                    label: arg.label,
                    select: arg.config.content
                  }
                  if(isReset){
                    nd.value = newJSON[nd.id]
                  }
                  this.dynamicData.push(nd)
                }
              }else if(arg.type === 'textarea'){
                let nd = {
                  id: arg.id,
                  type: 'textarea',
                  yield: false,
                  label: arg.label,
                  tips: arg.config.subtitle ? arg.config.subtitle.text : false,
                  value: '',
                  config: {
                    tips: arg.config.placeholder,
                    length: arg.config.word
                  }
                }
                if(isReset){
                  nd.value = newJSON[nd.id]
                }
                this.dynamicData.push(nd)
              }
            }
            //

            this.body_show = true;
            // console.log(this.dynamicData);
          })
        }else{

          get_selfstock_data({
            cid: q.cid,
            type: "tasktwo"
          })
          .then(data => {
            if(!mobileOrWin()){
              this.uploadImgBool = false;
            }
            this.body_show = true;
            let d = data.data;
            let path = this.$route.path;
            this.targetheadimg = d.resume_img ? d.resume_img : imgSrc || '';
            this.headImg = d.resume_img ? true : false;
            this.fullname = d.fullname ? d.fullname : getStorage(path, 'fullname') || '';
            this.intention_area = d.intention_area ? d.intention_area : getStorage(path, 'intention_area') || '';
            this.intention_career = d.intention_career ? d.intention_career : getStorage(path, 'intention_career') || '';
            this.intention_job = d.intention_job ? d.intention_job : getStorage(path, 'intention_job') || '';
            this.intention_work = data.intention_work;

            // 意向行业为其它行业
            if (this.intention_career == '0') {
              this.intention_career_name = '其它行业';
              this.intention_career_name_two = d.intention_career_name ? d.intention_career_name : getStorage(path, 'intention_career_name') || '';
              this.intention_job_name = d.intention_job_name ? d.intention_job_name : getStorage(path, 'intention_job_name') || '';
            }

            // 循环给意向行业赋值
            for (let i = 0; i < data.intention_work.length; i++) {
              // 给视图上的选择框赋值
              this.intention_career_group.push(data.intention_work[i].name);
              // 判断意向行业
              if (data.intention_work[i].id == d.intention_career) {
                // 给视图上的选择框赋值
                this.intention_career_name = data.intention_work[i].name;

                for (let k = 0; k < data.intention_work[i].job.length; k++) {
                  if (data.intention_work[i].job[k].id == d.intention_job) {
                    this.intention_job_name = data.intention_work[i].job[k].name;
                  }
                  this.intention_job_group.push(data.intention_work[i].job[k].name);
                }
                this.intention_job_group.push('其它岗位');
              }
            }

            // 意向行业不为其它行业并且求职岗位为其它岗位
            if (this.intention_career != '0' && this.intention_job == '0') {
              this.intention_job_name = '其它岗位';
              this.intention_job_name_two = d.intention_job_name ? d.intention_job_name : getStorage(path, 'intention_job_name') || '';

            }
            // 意向行业和求职岗位都为其它
            if (this.intention_career == '0' && this.intention_job == '0') {
              this.intention_career_name = '其它行业';
              this.intention_career_name_two = d.intention_career_name ? d.intention_career_name : getStorage(path, 'intention_career_name') || '';
              this.intention_job_name = '其它岗位';
              this.intention_job_name_two = d.intention_job_name ? d.intention_job_name : getStorage(path, 'intention_job_name') || '';
            }
            this.intention_career_group.push('其它行业');
          });
        }
      },
      pickerCareer(val) {
        if (val == '其它行业') {
          this.intention_career = '0';
        } else {
          for (let i = 0; i < this.intention_work.length; i++) {
            if (this.intention_work[i].name == val) {
              let s = [];
              for (let k = 0; k < this.intention_work[i].job.length; k++) {
                s.push(this.intention_work[i].job[k].name);
              }
              this.intention_job_group = s;
              this.intention_job_group.push('其它岗位');
              this.intention_career = this.intention_work[i].id;
            }
          }
        }

      },
      pickerJob(val) {
        if (val == '其它岗位') {
          this.intention_job = '0';
        } else {
          let s = [];
          for (let i = 0; i < this.intention_work.length; i++) {
            for (let k = 0; k < this.intention_work[i].job.length; k++) {
              if (this.intention_work[i].job[k].name == val) {
                this.intention_job = this.intention_work[i].job[k].id;
                return;
              }
            }
          }
        }
      },
      // 城市
      cityCancel() {
        this.citys_show = false;
      },
      cityConfirm(picker) {
        this.citys_show = false;
        let val = picker[0].name + ' ' + picker[1].name;
        this.intention_area = val;

      },
      cancel(data) {
        this.picker_show = false;

      },
      // 弹出选择框  1 意向行业、2 求职岗位
      confirm(data) {
        if (this.picker_type == 1) {
          this.intention_career_name = data;
          this.pickerCareer(data);
          this.intention_career_name_two = '';
          this.intention_job_name = '';
          this.intention_job_name_two = '';
        } else if (this.picker_type == 2) {
          this.intention_job_name = data;
          this.pickerJob(data);
          this.intention_job_name_two = '';
        }

        this.picker_show = false;

      },
      // 判断弹出是什么选择框
      pickerType(type) {
        // 1 意向行业、2 求职岗位
        this.picker_type = type;
        this.picker_show = true;

      },
      // 上传图片
      uploadImgHandle() {
        wx.chooseImage({
          count: 1,
          sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: (res) => {
            // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            wx.uploadImage({
              localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: (res) => {
                this.serverId = res.serverId;
                this.imgSave();
              }
            });
          }
        });
      },
      imgSave() {
        upload_image({
            cid: this.$route.query.cid,
            server_id: this.serverId
          })
          .then(data => {
            this.targetheadimg = data.headimgurl;
            this.headImg = true;
          });
      },
      // 验证非空
      validationHandle() {
        if (this.intention_career != '0' && this.intention_job != '0') {
          if (this.fullname != '' && this.intention_career_name != '' && this.intention_job_name != '' && this.intention_area != '' && this.headImg) {
            return true;
          }
        } else if (this.intention_career == '0' && this.intention_job == '0') {
          if (this.fullname != '' && this.intention_career_name != '' && this.intention_career_name_two != '' && this.intention_job_name_two != '' && this.intention_area != '' && this.headImg) {
            return true;
          }
        } else if (this.intention_career != '0' && this.intention_job == '0') {
          if (this.fullname != '' && this.intention_career_name != '' && this.intention_career_name != '' && this.intention_job_name_two != '' && this.intention_area != '' && this.headImg) {
            return true;
          }
        } else if (this.intention_career == '0') {
          if (this.fullname != '' && this.intention_career_name != '' && this.intention_career_name_two != '' && this.intention_job_name_two != '' && this.intention_area != '' && this.headImg) {
            return true;
          }
        } else {
          return false;
        }
      },
      // 提交数据
      submitHandle() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        update_selfstock_data({
            cid: this.$route.query.cid,
            type: "tasktwo",
            cpid: this.$route.query.pid,
            cptid: this.$route.query.id,
            iscreate: 1,
            fullname: this.fullname,
            intention_career: this.intention_career_name != '其它行业' ? this.intention_career : '0',
            intention_career_name: this.intention_career_name == '其它行业' ? this.intention_career_name_two : '',
            intention_job: (this.intention_career_name == '其它行业' || this.intention_job_name == '其它岗位') ? '0' : this.intention_job,
            intention_job_name: (this.intention_career_name == '其它行业' || this.intention_job_name == '其它岗位') ? this.intention_job_name_two : '',
            intention_area: this.intention_area,
          })
          .then(data => {
            this.$toast.clear();
            this.nextModule = true;
            this.objArg.cid = this.$route.query.cid;
            this.objArg.id = data.cptid;
            this.objArg.pid = this.$route.query.pid;
            this.objArg.name = encodeURIComponent(data.name);

          });
      },
      setTitle(){
        let title = this.$route.query.name;
        document.title = decodeURI(title);
      }
    },
    created() {
      this.pullData();
      this.setTitle();
      shareCon("course",this);
    },
    watch: {
      fullname(newVal, oldVal) {
        setStorage(this.$route.path, 'fullname', newVal);
      },
      intention_area(newVal, oldVal) {
        setStorage(this.$route.path, 'intention_area', newVal);
      },
      intention_career(newVal, oldVal) {
        setStorage(this.$route.path, 'intention_career', newVal);
      },
      intention_job(newVal, oldVal) {
        setStorage(this.$route.path, 'intention_job', newVal);
      },
      intention_career_name(newVal, oldVal) {
        setStorage(this.$route.path, 'intention_career_name', newVal);
      },
      intention_career_name_two(newVal, oldVal) {
        setStorage(this.$route.path, 'intention_career_name_two', newVal);
      },
      intention_job_name(newVal, oldVal) {
        setStorage(this.$route.path, 'intention_job_name', newVal);
      },
      intention_job_name_two(newVal, oldVal) {
        setStorage(this.$route.path, 'intention_job_name_two', newVal);
      }
    }
}
</script>
<style lang="scss" scoped>
@import "@s/taskStyle.scss";
.task-box.task2 {
  padding-bottom: 0;
  h3 {
    color: #EB5032;
    font-size: 32px;
    line-height: 42px;
  }
  h3.pj-task-h3 {
    color: #333;
    margin-top: 40px;
    span {
      color: #EB5032;
    }
    span.bt {
      border-bottom: 1px solid #EB5032;
    }
  }
  h3.task-small-h3 {
    color: #333;
  }
  .task_f {
    margin-top: 30px;
    .label {
      span {
        font-size: 24px;
        color: #666;
      }
      label {
        border-bottom: 1px solid #EB5032;
      }
      .noun{
        color: #EB5032;
      }
    }
    input {
      font-size: 26px;
    }
    .input-box {
      .son input {
        padding-left: 20px;
      }
    }
    .input-box.on {
      padding-left: 0;
      background-color: transparent
    }
    .input-box.upload-on {
      background-color: transparent;
      height: auto;
      margin-top: 20px;
      a {
        display: block;
        width: 120px;
        height: 120px;
        float: left;
        clear: both;
        margin-right: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      p {
        line-height: 120px;
        color: #666;
      }
    }
    .is-show {
      background-color: #ffffff;
      font-size: 26px;
      margin-top: 0;
      height: 70px;
      padding: 0 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-radius: 8px;
      margin-top: 20px;
    }
  }
  .explain {
    width: changeRem(13)+px;
    height: auto;
    border-radius: changeRem(0.16)+px;
    background: #fff;
    text-align: center;
    padding: changeRem(0.8)+px changeRem(1.2)+px;
    h2 {
      text-align: justify;
      margin-top: 0;
      font-size: changeRem(0.64)+px;
      color: #EB5032;
      font-weight: normal;
      margin-bottom: changeRem(0.2)+px;
    }
    .pps {
      color: #333;
      font-size: changeRem(0.52)+px;
      line-height: changeRem(0.8)+px;
      text-align: justify;
    }
  }
}
//
.task-plr-reset{
  padding-left: 0;
  padding-right: 0;
}
.task_ninput{
  .task_n{
    width: 60px;
  }
}
.mt-reset{
  margin-top: 0!important;
}
.in-block{
  display: inline-block;
}
.task_pb10{
  padding-bottom: 10px;
}
.project4-task-row{
  color: #666;
  word-wrap: break-word;
  word-break: normal;
  span{
    height: 69px;
    line-height: 69px;
    padding: 0 10px;
    display: block;
  }
}
</style>
<style lang="scss">
.grouping {
  .van-cell {
    .van-cell__value {
      input {
        font-size: 26px;
      }
    }
  }
}
.project3-task1{
  .van-cell{
    .van-cell__value{
      input{
        width: 2.5rem;
      }
    }
  }
}
</style>
